/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateDateFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/date/create-update/form-edit-create-update-date-field-dialog.component';
/* eslint-enable */

/**
 * Date field implementation.
 */
export class FormEditDateFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateDateFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateDateFieldDialogComponent)
      .create(this.injector);
  }

}
